// Agenda de Natal: regras partilhadas entre a loja, o painel e o servidor (worker/agenda.ts).
// O fecho é sempre a hora de Lisboa (Europe/Lisbon), com ou sem horário de verão.
const TZ = "Europe/Lisbon";
const LOCAL_RE = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;

// Diferença (em ms) entre a hora de Lisboa e o UTC no instante dado.
const offsetAt = (utcMs) => {
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: TZ, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }).formatToParts(new Date(utcMs));
  const v = Object.fromEntries(parts.map((p) => [p.type, Number(p.value)]));
  return Date.UTC(v.year, v.month - 1, v.day, v.hour, v.minute, v.second) - Math.floor(utcMs / 1000) * 1000;
};

/** "2026-12-01T23:59" (hora de Lisboa) -> ISO em UTC. Devolve null se o texto não for uma data válida. */
export const lisbonLocalToIso = (local) => {
  const m = LOCAL_RE.exec(String(local ?? ""));
  if (!m) return null;
  const [y, mo, d, h, mi] = m.slice(1).map(Number);
  const wall = Date.UTC(y, mo - 1, d, h, mi);
  const back = new Date(wall);
  if (back.getUTCFullYear() !== y || back.getUTCMonth() !== mo - 1 || back.getUTCDate() !== d || back.getUTCHours() !== h) return null;
  // Duas passagens chegam para acertar a hora nas mudanças de hora.
  let utc = wall - offsetAt(wall);
  utc = wall - offsetAt(utc);
  return new Date(utc).toISOString();
};

/** Hoje, em Lisboa (AAAA-MM-DD). */
export const lisbonToday = (ms = Date.now()) => new Date(ms + offsetAt(ms)).toISOString().slice(0, 10);

/** Há uma encomenda "tocada" por esta agenda? Verdade quando a agenda fecha o que a cliente tem no carrinho. */
export const blocksCart = (agenda, slugs) => {
  if (!agenda) return false;
  if (agenda.suspended) return true;
  if (agenda.status !== "closed") return false;
  if (agenda.scope === "all" || !agenda.coveredSlugs) return true;
  return slugs.some((s) => agenda.coveredSlugs.includes(s));
};

/** Dias, horas, minutos e segundos que faltam (0 quando já passou). */
export const timeLeft = (closesAtIso, nowMs) => {
  const ms = Math.max(0, new Date(closesAtIso).getTime() - nowMs);
  const s = Math.floor(ms / 1000);
  return { done: ms <= 0, days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), minutes: Math.floor((s % 3600) / 60), seconds: s % 60 };
};
